/**
 * StarMeter — pure star counter (no Phaser).
 *
 * Stars fund the SPECIAL+UP super move. One free star is granted at stage
 * start; more come from pickups (MY-1438+). Cap is STAR_CAP = 9.
 */

export const STAR_CAP = 9;
export const STAR_START = 1;

export interface StarMeterState {
  count: number;
}

export function createStarMeter(): StarMeterState {
  return { count: STAR_START };
}

/** Award a pickup star. Returns false if already at cap. */
export function addStar(state: StarMeterState): boolean {
  if (state.count >= STAR_CAP) return false;
  state.count += 1;
  return true;
}

/** Spend one star. Returns false if none available. */
export function consumeStar(state: StarMeterState): boolean {
  if (state.count <= 0) return false;
  state.count -= 1;
  return true;
}

export function canUseStar(state: StarMeterState): boolean {
  return state.count > 0;
}
